import { render } from "./ArticleDetail.vue?vue&type=template&id=153c09cc&scoped=true"
import script from "./ArticleDetail.vue?vue&type=script&lang=ts"
export * from "./ArticleDetail.vue?vue&type=script&lang=ts"

import "./ArticleDetail.vue?vue&type=style&index=0&id=153c09cc&lang=scss"
import "./ArticleDetail.vue?vue&type=style&index=1&id=153c09cc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-153c09cc"

export default script